/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Creations_DescriptionInputs */

const id_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Irama bulanan dan tahunan dari kreasi baru yang mendarat di toko.`)
};

const ms_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadens bulanan dan tahunan ciptaan baharu yang mendarat di kedai.`)
};

const da_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlig og årlig kadence af nye oprettelser der lander på butikken.`)
};

const de_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlicher und jährlicher Rhythmus neuer Kreationen im Store.`)
};

const en_us2_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly and yearly cadence of new creations landing on the store.`)
};

const es_es2_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritmo mensual y anual de nuevas creaciones que llegan a la tienda.`)
};

const es_mx2_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritmo mensual y anual de nuevas creaciones que llegan a la tienda.`)
};

const fil_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buwanan at taunang dalas ng mga bagong creation na dumarating sa tindahan.`)
};

const fr_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rythme mensuel et annuel des nouvelles créations arrivant sur le store.`)
};

const it_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadenza mensile e annuale delle nuove creazioni che arrivano sul negozio.`)
};

const hu_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havi és éves ütem az áruházba érkező új létrehozásokról.`)
};

const nl_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijkse en jaarlijkse cadans van nieuwe creaties die in de winkel verschijnen.`)
};

const no_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlig og årlig kadens av nye opprettelser som lander i butikken.`)
};

const pl_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miesięczne i roczne tempo nowych tworów pojawiających się w sklepie.`)
};

const pt_br2_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadência mensal e anual de novas criações chegando à loja.`)
};

const pt_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadência mensal e anual de novas criações a chegar à loja.`)
};

const ro_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadența lunară și anuală a noilor creații care ajung în magazin.`)
};

const fi_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusien luontien kuukausi- ja vuositahti kaupassa.`)
};

const sv_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månads- och årstakt av nya skapelser som landar i butiken.`)
};

const vi_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhịp hàng tháng và hàng năm của các sáng tạo mới trên cửa hàng.`)
};

const tr_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağazaya gelen yeni oluşturmaların aylık ve yıllık temposu.`)
};

const cs_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měsíční a roční kadence nových vytvoření na obchodě.`)
};

const bg_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месечен и годишен ритъм на нови създавания в магазина.`)
};

const ru_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячная и ежегодная частота появления новых предложений в магазине.`)
};

const uk_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щомісячна та щорічна динаміка нових створень у магазині.`)
};

const ar_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإيقاع الشهري والسنوي للإنشاءات الجديدة على المتجر.`)
};

const hi_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टोर पर नए निर्माणों की मासिक और वार्षिक दर।`)
};

const th_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จังหวะรายเดือนและรายปีของการสร้างใหม่บนร้านค้า`)
};

const ja_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアに新しく作成されたものの月別・年別の頻度。`)
};

const zh_cn2_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月和每年的新内容发布频率。`)
};

const zh_hant1_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月和每年的新內容發布頻率。`)
};

const ko_stats_creations_description = /** @type {(inputs: Stats_Creations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어에 새로 생성되는 항목의 월별 및 연별 추이입니다.`)
};

/**
* | output |
* | --- |
* | "Monthly and yearly cadence of new creations landing on the store." |
*
* @param {Stats_Creations_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_creations_description = /** @type {((inputs?: Stats_Creations_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Creations_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_creations_description(inputs)
	if (locale === "ms") return ms_stats_creations_description(inputs)
	if (locale === "da") return da_stats_creations_description(inputs)
	if (locale === "de") return de_stats_creations_description(inputs)
	if (locale === "en-US") return en_us2_stats_creations_description(inputs)
	if (locale === "es-ES") return es_es2_stats_creations_description(inputs)
	if (locale === "es-MX") return es_mx2_stats_creations_description(inputs)
	if (locale === "fil") return fil_stats_creations_description(inputs)
	if (locale === "fr") return fr_stats_creations_description(inputs)
	if (locale === "it") return it_stats_creations_description(inputs)
	if (locale === "hu") return hu_stats_creations_description(inputs)
	if (locale === "nl") return nl_stats_creations_description(inputs)
	if (locale === "no") return no_stats_creations_description(inputs)
	if (locale === "pl") return pl_stats_creations_description(inputs)
	if (locale === "pt-BR") return pt_br2_stats_creations_description(inputs)
	if (locale === "pt") return pt_stats_creations_description(inputs)
	if (locale === "ro") return ro_stats_creations_description(inputs)
	if (locale === "fi") return fi_stats_creations_description(inputs)
	if (locale === "sv") return sv_stats_creations_description(inputs)
	if (locale === "vi") return vi_stats_creations_description(inputs)
	if (locale === "tr") return tr_stats_creations_description(inputs)
	if (locale === "cs") return cs_stats_creations_description(inputs)
	if (locale === "bg") return bg_stats_creations_description(inputs)
	if (locale === "ru") return ru_stats_creations_description(inputs)
	if (locale === "uk") return uk_stats_creations_description(inputs)
	if (locale === "ar") return ar_stats_creations_description(inputs)
	if (locale === "hi") return hi_stats_creations_description(inputs)
	if (locale === "th") return th_stats_creations_description(inputs)
	if (locale === "ja") return ja_stats_creations_description(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_creations_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_creations_description(inputs)
	return ko_stats_creations_description(inputs)
});
export { stats_creations_description as "stats.creations.description" }